import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from './routes/public/auth'
import dashboard from './routes/general/dashboard'
import store from '../store'
import domains_index from './routes/domain'
import dns_index from './routes/dns'
import datacenter_index from './routes/datacenter'
import ssl_index from './routes/ssl'
import account_index from './routes/account'
import accounting_index from './routes/accounting'
import rz_index from './routes/rz'
import licence_index from './routes/licence'
import tools_index from './routes/tools'
import support_index from './routes/support'
// import samples_index from '.routes/samples'
Vue.use(VueRouter);

const flattenRoutes = (routes, newRoutes = []) => {
  return newRoutes.reduce((previous, current) => {
    return [...previous, ...(current.length > 0 ? current : [current])]
  }, routes)
};

const routes = flattenRoutes([], [
  auth,
  account_index,
  accounting_index,
  dashboard,
  domains_index,
  datacenter_index,
  dns_index,
  ssl_index,
  rz_index,
  licence_index,
  tools_index,
  support_index,
  // samples_index
]);

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  const middlewareName = to.meta.middleware
  if (!middlewareName)
    return next()

  const middleware = Array.isArray(middlewareName) ? middlewareName : [middlewareName]

  const context = {
    from,
    to,
    next,
    router,
  }

  middleware[0]({
    ...context,
    next: function() {}
  })

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js